import { Button } from "@/components/ui/button";
import { useLanguage } from "@/i18n/LanguageContext";
import { usePlanPreview } from "@/hooks/usePlanUi";
import { START_WELCOME_TOUR_EVENT, welcomePlanFor } from "@/components/dashboard/WelcomeTour";

/**
 * Lanza la bienvenida en modo prueba con el plan elegido en el selector
 * (Lite, Básico, Club Pro, Avanzado; Admin/Visitante usan Lite). No guarda nada.
 */
export default function AdminWelcomeTourButton({ className }: { className: string }) {
  const { lang } = useLanguage();
  const es = lang === "es";
  const preview = usePlanPreview();
  const start = () => window.dispatchEvent(new CustomEvent(START_WELCOME_TOUR_EVENT, { detail: { plan: welcomePlanFor(preview) } }));
  return (
    <Button type="button" size="sm" variant="outline" className={className} onClick={start}>
      <span>{es ? "Probar bienvenida" : "Test welcome"}</span>
    </Button>
  );
}
